import { useState } from "react";

// Logo de marque TyCopro (lockup « logo + typo »).
//
// - variant "color" : logo en couleur, pour fonds clairs (header, fonds blancs).
// - variant "white" : logo blanc/monochrome, pour fonds foncés (footer primary-950).
//
// Le composant affiche le fichier SVG déposé dans `public/static/brand/`. Tant que
// l'asset n'est pas fourni (ou s'il échoue à charger), il retombe sur `fallback`
// (le branding actuel : icône + texte) pour ne JAMAIS dégrader l'affichage — la
// bascule vers le vrai logo est donc transparente dès que le fichier est ajouté.
//
// Format = PNG (les fichiers de marque fournis sont en PNG ; aucun SVG disponible).
// Le même PNG couleur sert aussi aux emails (backend/email_service.py).
export default function BrandLogo({ variant = "color", className = "", alt = "TyCopro", fallback = null, loading = "eager", fetchPriority }) {
    const [failed, setFailed] = useState(false);
    const name = variant === "white" ? "logo-tycopro-blanc" : "logo-tycopro-couleur";
    // Le fichier `-2x.png` (303x100) est la version dimensionnée pour l'affichage
    // réel du lockup (~150x50 CSS, soit 2x sur écrans HiDPI). Les fichiers pleine
    // taille (631x208) restent utilisés pour les emails et les usages hors web.
    const src = `${process.env.PUBLIC_URL || ""}/static/brand/${name}-2x.png`;

    if (failed && fallback) return fallback;

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            // width/height intrinsèques : réservent le ratio et évitent le CLS
            // (audit Lighthouse « Image elements do not have explicit width and height »).
            width={303}
            height={100}
            loading={loading}
            fetchpriority={fetchPriority}
            onError={() => setFailed(true)}
            decoding="async"
        />
    );
}
